import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { compose } from 'recompose'
import { Button, SelectOption } from 'components/misc'
import { form } from 'helpers/decorators'
import { validateUnassignedParticipants } from 'models/tasks'
import { apiOrganizations } from 'helpers/decorators/api'
import { mapLeaders } from 'helpers/mapForSelect'
import { Modal } from 'containers/misc'
import AssignAwardLeader from '../../award-leaders/AssignAwardLeader/AssignAwardLeader'
import uuid from 'uuid'

const enhance = compose(
  injectIntl,
  apiOrganizations({
    leaders: true,
    disableLimit: true,
    excludeInactive: true
  }),
  connect(({ auth }) => ({
    user: auth.user
  })),
  form({
    validate: validateUnassignedParticipants,
    disableHook: true
  })
)

class TasksAssignLeader extends Component {
  static propTypes = {
    values: PropTypes.object,
    organizations: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    id: PropTypes.number,
    handleSubmit: PropTypes.func.isRequired,
    assignLeader: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    isGlobalRole: PropTypes.bool.isRequired,
    modal: PropTypes.func.isRequired,
    orgId: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
  }

  state = {
    orgId: null
  }

  handleOpenModal = orgId => {
    this.setState({ orgId })
    this.props.modal(`assigned-award-leader-modal-${this.key}`)
  }

  getAssignForm = () => {
    const {
      user,
      handleSubmit,
      assignLeader,
      id,
      intl,
      isGlobalRole,
      orgId,
      organizations: { leaders }
    } = this.props

    if(isGlobalRole){
      return (<div>
        <Button
            tiny
            type="button"
            intlKey="button.assign"
            onClick={() => this.handleOpenModal(orgId)}
        >
          <FormattedMessage
              id="button.assign"
              defaultMessage="Assign"
          />
        </Button>
      </div>)
    } else {
      const options = mapLeaders(leaders, user, intl, false)

      return (<form onSubmit={handleSubmit(fields => assignLeader(id, fields))}>
        <SelectOption options={options} id={id} values={this.props.values} />
      </form>)
    }
  }

  render() {
    const {
      assignLeader,
      id,
      user,
      intl,
      modal
    } = this.props

    return (<div>{this.getAssignForm()}
      <Modal id={`assigned-award-leader-modal-${this.key}`} customActions enableOverflow showCloseBtn>
        <AssignAwardLeader
            assignLeader={assignLeader}
            awardId={id}
            user={user}
            intl={intl}
            orgId={this.state.orgId}
            modal={modal}
        />
      </Modal>
    </div>)
  }
}

export const TasksAssignLeaderOffline = compose(
  injectIntl,
  connect(({ auth }) => ({
    user: auth.user
  })),
  form({
    validate: validateUnassignedParticipants,
    disableHook: true
  })
)(TasksAssignLeader)

export default enhance(TasksAssignLeader)
